module.exports = __webpack_public_path__ + "asset/daxieTitle_cPIN76l5.png";